<div class="row">
  <div class="col-sm-12 text-center">
    <h2 translate>FEATURE_INACTIVE</h2>
    <span translate>FEATURE_INACTIVE_CONTACT_SALES</span>
  </div>
</div>
